module.exports = __webpack_public_path__ + "img/49.start_clean_zone.bf2bfb20.svg";